module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "urbDHPXfkJglm5sV43yPgk7"
    }
  }, [_c('span', {
    staticClass: "Bold"
  }, [_c('a', {
    attrs: {
      "id": "uJoaJdhCnJS5MXlE7GSjdgG"
    }
  }), _vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH _idGenParaOverride-1"
  }, [_vm._v("To my friend and respected homicide detective Leslie Van Buskirk, who never gave up. But most of all, my thanks to the Indianapolis Fire Investigation Unit and the Indianapolis Police Department’s homicide detectives for their skill and tenacity.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d071e90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/dedication.vue
// module id = 69
// module chunks = 0